import { RadioGroup } from 'design-components';
import React from 'react';
import { UserPermissionRole } from 'utilities/enum-utils';
import { ADVANCED_PERMISSION_ROLE_TYPE } from 'views/team-v2/utils/constants';
import ActionSelectedItem from '../ActionSelectedItem';
import AdvancedPermissionRow from '../AdvancedPermissionRow';

interface IProps {
  permissionRoleId: number;
  changePermissionForEachRole?: (value: number, permissionKey: string) => void;
  typePermissionPresent: string;
  handleSetTypePermissionPresent: (value: string) => void;
}

const PermissionPlanManagementSection: React.FC<IProps> = ({
  permissionRoleId = UserPermissionRole.NoAccess,
  changePermissionForEachRole,
  typePermissionPresent,
  handleSetTypePermissionPresent,
}) => {
  return (
    <AdvancedPermissionRow
      title="Plan Management"
      description="Access to plan management area of GoodHuman"
      permissionRoleId={permissionRoleId}
      type={ADVANCED_PERMISSION_ROLE_TYPE.PLAN_MANAGEMENT}
      typePermissionPresent={typePermissionPresent}
      handleSetTypePermissionPresent={handleSetTypePermissionPresent}
      extendPermissions={
        <RadioGroup
          aria-label="planManagement"
          value={permissionRoleId}
          onChange={(value) => changePermissionForEachRole(value, 'planManagement')}
        >
          <ActionSelectedItem
            ariaLabel="plan-management-no-access"
            label="No access, cannot view or access this section"
            value={UserPermissionRole.NoAccess}
            selectedPermission={permissionRoleId}
          />
          <ActionSelectedItem
            ariaLabel="plan-management-access"
            label="Access, can see and perform all actions within this section"
            value={UserPermissionRole.PlanManager}
            selectedPermission={permissionRoleId}
          />
        </RadioGroup>
      }
    />
  );
};

export default PermissionPlanManagementSection;
